import { apiSlice } from "../../app/api/apiSlice";

export const getEnhancedConditionsDocumentsListByCategoryApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getEnhancedConditionsDocumentsListByCategory: builder.mutation({
			query: (credentials) => ({
				url: `api/v1/loan/get_enhanced_conditions/${credentials.loanGuid}/${credentials.conditionType}`,
				method: "GET",
			}),
		}),
	}),
});

export const { useGetEnhancedConditionsDocumentsListByCategoryMutation: useEnhancedConditionsDocumentsListByCategoryMutation } =
	getEnhancedConditionsDocumentsListByCategoryApiSlice;